import client from './index'

const getData = (data, url) => client['api'].get(url, {params: data})
const getDataFromStudent = (data,student_id, url) => client['api'].get(`${url}/fromstudent/${student_id}`, {params: data})
const getGuidanceById = (id, url, student_id, type) => client['api'].get(`${url}/${id}`, {params: {student_id: student_id, type: type}})
const store = (data,url) => client['api'].post(url, data)
const update = (data,id,url) => client['api'].patch(`${url}/${id}`, data)
const destroy = (id,url) => client['api'].delete(`${url}/${id}`)

// KRS
const getDataKRS = (data) => client['api'].get(`study-plan-guidance`, {params: data})
const getDataKRSFromStudent = (data, student_id) => client['api'].get(`study-plan-guidance/fromstudent/${student_id}`, {params: data})
const studyCourseByGuidanceId = (guidance_id, student_id) => client['api'].get(`/study-plan/courses/${guidance_id}`, {params: {student_id: student_id}})
const storeKRS = (data) => client['api'].post(`study-plan-guidance`, data)
const updateDetailKRS = (data,id) => client['api'].patch(`study-plan-guidance/detail/${id}`, data)
const deleteKRS = (id) => client['api'].delete(`study-plan-guidance/${id}`)
const acceptedByLecture = (id) => client['api'].post(`study-plan-guidance/accept/${id}`)
const rejectWithRecomendation = (id, data) => client['api'].post(`study-plan-guidance/rejection/${id}`, data)

export {
    getData,
    store,
    update,
    destroy,
    getGuidanceById,
    getDataFromStudent,
    getDataKRS,
    storeKRS,
    updateDetailKRS,
    deleteKRS,
    getDataKRSFromStudent,
    acceptedByLecture,
    rejectWithRecomendation,
    studyCourseByGuidanceId
}